
/**
 * By default TypeScript incorrectly infers the result of getting an array value
 * by index to be T instead of T|undefined. This helper function corrects that for
 * cases where it's needed.
 */
const getIndex = <T>(array: T[], index: number): T | undefined => array[index];

export default getIndex;
